import camelCase from 'lodash/camelCase';

import { showErrorMessage } from '@/components/common/errorMessage';


// Maps backend field errors onto antd validateInfos, then surfaces the rest.
export const applyFieldErrors = (validateInfos, errors, fields) => {
	fields.forEach(element => {
		if (errors[element]) {
			const jsElement = camelCase(element);
			validateInfos[jsElement] = {
				...validateInfos[jsElement],
				validateStatus: 'error',
				help: errors[element],
			};
			delete errors[element];
		}
	});
	showErrorMessage(errors);
};


export const runValidatedSubmit = (validate, isSubmitting, submitFn) => {
	validate().then(() => {
		isSubmitting.value = true;
		submitFn();
	}).catch(err => {
		console.log('error', err);
	});
};
